<template>
    <div class="scroll-container">
        <div class="container1">
            <div class="title">企业信息 <span class="button" @click="sumbit"> {{ (isSave)  ? '保存' :'修改' }} </span></div>
            <el-form
                :model="form"
                :rules="rules"
                class="dialogForm"
                label-width="160px"
                style="width: 60%; padding: 30px 0;"
            >

              <el-form-item label="企业logo" prop="image">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="uploadedFiles">
                  <img v-if="form.image" :src="baseUrl+form.image" class="avatar" @click="handlePreview(form.image)">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <el-button v-if="isSave"  slot="trigger" size="small" type="primary"> 点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="企业名称" prop="qymc">
                  <el-input
                      v-model="form.qymc"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                      :disabled="true"
                  />
              </el-form-item>
              <el-form-item label="社会统一信用代码" prop="dm">
                  <el-input
                      v-model="form.dm"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                      :disabled="true"
                  />
              </el-form-item>
              <el-form-item label="法人代表" prop="fddbr">
                  <el-input
                      v-model="form.fddbr"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                      :disabled="true"
                  />
              </el-form-item>
              <el-form-item label="身份证号" prop="fddbrsfzh">
                  <el-input
                      v-model="form.fddbrsfzh"
                      clearable
                      placeholder="请输入"
                      show-word-limit
                      :disabled="true"
                  />
              </el-form-item>
            </el-form>


            <div class="title">联系人信息</div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                class="dialogForm"
                label-width="160px"
                style="width: 60%; padding: 30px 0;"
            >
                <el-form-item label="联系人" prop="lxrxm">
                    <el-input
                        v-model="form.lxrxm"
                        clearable
                        placeholder="请输入"
                        show-word-limit
                        :disabled="true"
                    />
                </el-form-item>
                <el-form-item label="联系电话" prop="lxrdh">
                    <el-input
                        v-model="form.lxrdh"
                        clearable
                        placeholder="请输入"
                        show-word-limit
                        :disabled="!isSave"
                    />
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input
                        v-model="form.email"
                        clearable
                        placeholder="请输入"
                        show-word-limit
                        :disabled="!isSave"
                    />
                </el-form-item>
            </el-form>


            <div class="title">营业执照</div>
            <el-form
                :model="form"
                :rules="rules"
                class="dialogForm"
                label-width="160px"
                style="width: 60%; padding: 30px 0;"
            >

              <el-form-item label="营业执照" prop="yyzz">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess2"
                  :before-upload="uploadedFiles2">
                  <img v-if="form.yyzz" :src="baseUrl+form.yyzz" @click="handlePreview(form.yyzz)" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <el-button v-if="isSave" slot="trigger" size="small" type="primary"> 点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>

        </div>
    </div>
</template>

<script>
import { uploadFiles } from '@/api/index'
import {getFinancialInsDetails , editFinaInstitution} from "@/views/financInstitutionPC/viewApi";
import { validateForm ,validateCellPhone } from '@/utils'


export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      form:{
        qymc:'',
        image:'',
      },
      isSave:false,
      rules: {
        phone: [
          {
            required: true,
            message: "请输入联系人手机号",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: "请输入正确的联系方式",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/,
            message: "请输入合法的邮箱",
            trigger: ["blur", "change"],
          },
        ],
      },
    }
  },
  mounted() {
    this.queryData();
  },
  methods: {
    queryData(){
      getFinancialInsDetails().then(res => {
        if (res.code == 1000) {
          this.form={...res.data}
        }
      })
    },

    //上传
    uploadedFiles (file) {
        let formData = new FormData();
        formData.append('file', file)  
        uploadFiles(formData).then(( res )=>{
          if(res.data){
            this.form.image = res.data.url;
            // this.editInfo();
          }
        })
    },
    handleAvatarSuccess(res, file) {
    },

    uploadedFiles2 (file) {
        let formData = new FormData();
        formData.append('file', file)  
        uploadFiles(formData).then(( res )=>{
          if(res.data){
            this.form.yyzz = res.data.url;
            // this.editInfo();
          }
        })
    },
    handleAvatarSuccess2(res, file) {

    },
    handlePreview(url){
      var a = document.createElement('a');
      a.target = '_blank';
      a.href = this.baseUrl + url;
      document.body.appendChild(a) 
      a.click() // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove() // 一
    },


    async sumbit() {

      if(this.isSave ){

      if (!validateForm(this.$refs["form"])) {
          this.$baseMessage("表单信息缺失。", "error");
          return;
        }

        let params = {
          ...this.form,
        };
        let res = await editFinaInstitution(params);
        if (res.code == 1000) {
          this.isSave = false;
          this.$baseMessage("修改成功。", "success");
        }
      }else{

        this.isSave = true;

      }

    },

    editInfo(){
      editFinaInstitution(this.form).then((res)=>{
        this.$baseMessage('修改成功。', 'success')
      })
    }



  }
};
</script>
<style lang="scss" >
.scroll-container{

  .container1{
      background: #fff;
      padding: 20px;
      border-radius: 16px;
      .title{
          margin-top: 10px;
          margin-left: 5px;
          height: 35px;
          width: 100%;
          line-height: 35px;
          font-size: 15px;
          font-weight: 800;
          border-bottom: 1px solid #c4c6ca;

          .button {
            float: right;
            margin-right: 230px;
            display: inline-block;
            margin-bottom: 10px;
            border: 1px solid #1366ec;
            padding: 5px 25px;
            border-radius: 5px;
            color: #fff;
            background: #1366ec;
            cursor: pointer;
            line-height: 20px;
          }
      }
  }
  
}
.avatar-uploader .el-upload {
    // border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

</style>